import { useProductCollection } from 'hooks/product/useProductCollection';
import { env } from 'lib/constants/env';
import NextLink from 'next/link';
import type { ProductCarousel } from 'types/cms/blocks/ProductCarousel';

import { ProductCardCarousel } from '.';

interface ProductCarouselWrapperProps {
  productCarousel: ProductCarousel;
  fallbackCta?: {
    title: string;
    href: string;
  };
}

export function ProductCarouselWrapper({
  productCarousel,
  fallbackCta,
  ...props
}: ProductCarouselWrapperProps) {
  const isSkincareCardEnabled = env.NEXT_PUBLIC_SKINCARE_CARDS_ENABLED;
  const { title, productCollection, plpRef, isSkincareCardVisible } =
    productCarousel;
  const products = useProductCollection(productCollection);

  const cta = plpRef
    ? {
        title: plpRef.label.includes('Shop')
          ? plpRef.label
          : `Shop ${plpRef.label}`,
        href: plpRef.href,
        as: NextLink,
      }
    : fallbackCta;

  return (
    <ProductCardCarousel
      title={title}
      products={products}
      collectionName={productCollection.name}
      cta={cta}
      isSkincareCardVisible={isSkincareCardEnabled && isSkincareCardVisible}
      {...props}
    />
  );
}
